import { memo, type ReactNode } from 'react'

interface AdminLayoutProps {
  sidebar: ReactNode
  children: ReactNode
}

export const AdminLayout = memo(({ sidebar, children }: AdminLayoutProps) => (
  <div className="app-layout">
    {sidebar}
    <div className="page-content">{children}</div>
  </div>
))

AdminLayout.displayName = 'AdminLayout'
